export default __webpack_public_path__ + "static/media/toggle-off.503b08a3.svg";